import React from "react";
import { features } from "../data/mockData";
import {
  MessageCircle,
  Award,
  Settings,
  Clock,
  Shield,
  GraduationCap,
} from "lucide-react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const iconMap = {
  MessageCircle,
  Award,
  Settings,
  Clock,
  Shield,
  GraduationCap,
};

const ServicesSection = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <section id="services" className="py-28 bg-white">
      <div className="max-w-[1200px] mx-auto px-6">
        {/* Header */}
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
          className="text-center mb-16"
        >
          <p className="text-sm font-medium text-[#4a7c59] tracking-widest uppercase mb-3">
            Unsere Leistungen
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1d1d1f] tracking-tight mb-5">
            Was uns auszeichnet.
          </h2>
          <p className="text-lg text-[#6e6e73] max-w-xl mx-auto">
            Qualität, Zuverlässigkeit und erstklassiger Service – dafür stehen wir.
          </p>
        </motion.div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => {
            const Icon = iconMap[feature.icon];
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 40 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="group p-8 rounded-3xl bg-[#f5f5f7] hover:bg-white border border-transparent hover:border-[#e5e5e5] hover:shadow-xl hover:shadow-black/5 transition-all duration-500 cursor-default"
              >
                <div className="w-12 h-12 rounded-2xl bg-[#4a7c59]/10 flex items-center justify-center mb-5 group-hover:bg-[#4a7c59] group-hover:scale-110 transition-all duration-500">
                  <Icon
                    size={22}
                    className="text-[#4a7c59] group-hover:text-white transition-colors duration-500"
                  />
                </div>
                <h3 className="text-lg font-semibold text-[#1d1d1f] mb-2 tracking-tight">
                  {feature.title}
                </h3>
                <p className="text-sm text-[#6e6e73] leading-relaxed">
                  {feature.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
